import { InvoicePermissions } from '@/permissions';

export enum QuotePermissions {
  Manage = 'quote:manage',
  ViewQuoteApprove = 'quote-approve:view',
  ViewTabSection = 'quote-section:view',
}

export enum OrganApprovalPermissions {
  View = 'organ-approval:view',
  Manage = 'organ-approval:manage',
}

export enum ServiceApprovalPermissions {
  View = 'service-approval:view',
  Manage = 'service-approval:manage',
}

export enum OrganAcceptanceCriteriaPermissions {
  View = 'organ-acceptance-criteria:view',
  Manage = 'organ-acceptance-criteria:manage',
}

export enum DefaultOrganAcceptanceCriteriaPermissions {
  View = 'default-organ-acceptance-criteria:view',
  Manage = 'default-organ-acceptance-criteria:manage',
}

export enum TxCenterORPermissions {
  Manage = 'tx-center-or:manage',
  ManageOnCaseAssigned = 'tx-center-or-on-case-assigned:manage',
}

export enum AttachmentSectionPermissions {
  View = 'attachments:view',
}

export enum OrganizationPermissions {
  View = 'organization:view',
  Manage = 'organization:manage',
}

export enum OrganizationUserManagePermissions {
  UserEdit = 'organization-user:edit',
  UserDelete = 'organization-user:delete',
  UserActiveToggle = 'organization-user:active-toggle',
}

export enum OrganizationUserPermissions {
  View = 'organization-user:view',
  Create = 'organization-user:create',
  Manage = 'organization-user:manage',
}

export enum CasePermissions {
  Create = 'case:create',
  CaseDetailsViewTab = 'case-details-tab:view',
  CaseDetailsManageTab = 'case-details-tab:manage',
  CaseTeamViewTab = 'case-team-tab:view',
  CaseTeamManageTab = 'case-team-tab:manage',
  CaseClinicalLogViewTab = 'case-clinical-log-tab:view',
  CaseClinicalLogManageTab = 'case-clinical-log-tab:manage',
  CaseActivitiesViewTab = 'case-activities-tab:view',
}

export enum ArchivePermissions {
  View = 'archive:view',
  CaseDetailsViewTab = 'archive-details-tab:view',
  CaseTeamViewTab = 'archive-team-tab:view',
  ClinicalLogViewTab = 'archive-clinical-log-tab:view',
  ActivitiesViewTab = 'archive-activities-tab:view',
}
export enum OPOsPermissions {
  View = 'opos:view',
  Manage = 'opos:manage',
}
export enum TrialPermissions {
  RandomizationView = 'trial-randomization:view',
  RandomizationManage = 'trial-randomization:manage',
}

export enum OfferPermissions {
  Manage = 'offer:manage',
}

export type PermissionType = RootPermissionType | NestedPermissionType;

export type RootPermissionType =
  | CasePermissions
  | QuotePermissions
  | OrganApprovalPermissions
  | ServiceApprovalPermissions
  | TxCenterORPermissions
  | AttachmentSectionPermissions
  | DefaultOrganAcceptanceCriteriaPermissions
  | OrganizationPermissions
  | OrganizationUserPermissions
  | OrganAcceptanceCriteriaPermissions
  | ArchivePermissions
  | InvoicePermissions
  | OPOsPermissions
  | TrialPermissions
  | OfferPermissions;

export type NestedPermissionType = OrganizationUserManagePermissions;
